import type { User } from '@/api'
import useHierarchisedGroups from '@/hooks/hierarchised-groups'
import {
  agencyMembershipsToNames,
  collectAgencyMembershipsByUserRecord,
  type AgencyMembershipsByUser,
} from '@/hooks/hierarchised-groups/collectAgencyMembershipsByUser'
import { collectAllGroupMembers } from '@/hooks/hierarchised-groups/collectGroupMembers'
import { useMemo } from 'react'

export function useFlattenedOrganizationMembers(): {
  members: User[]
  agenciesByUserId: Record<string, string[]>
  agencyMembershipsByUserId: AgencyMembershipsByUser
  isLoading: boolean
} {
  const { hierarchisedGroups, isLoading } = useHierarchisedGroups()

  const members = useMemo(
    () => collectAllGroupMembers(hierarchisedGroups),
    [hierarchisedGroups]
  )

  const agencyMembershipsByUserId = useMemo(
    () => collectAgencyMembershipsByUserRecord(hierarchisedGroups),
    [hierarchisedGroups]
  )

  const agenciesByUserId = useMemo(() => {
    const out: Record<string, string[]> = {}
    for (const [uid, memberships] of Object.entries(agencyMembershipsByUserId)) {
      out[uid] = agencyMembershipsToNames(memberships)
    }
    return out
  }, [agencyMembershipsByUserId])

  return { members, agenciesByUserId, agencyMembershipsByUserId, isLoading }
}
